import { useRef, useCallback } from 'react';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

export const useEventCallback = (
  fn,
) => {
  const ref = useRef(fn);

  useIsomorphicLayoutEffect(() => {
    ref.current = fn;
  });

  const callback = useCallback(
    (...args) =>
      (0, ref.current)(...args),
    [],
  );

  return callback;
};
